export default "__VITE_PUBLIC_ASSET__c888a6fa__"